import axios from "axios"
import { BaseUrl, JsonConfig, jwtToken } from "./BaseRepository";
import { ErrorMessage, InfoMessage, SuccessMessage } from "../Utils/Utils";
import fileDownload from "js-file-download";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

export const dwnldCanadaAutocrawl = async () => {
    try {
        let url = `${BaseUrl}Home/autocrawlCanada`;
        const res = await axios.get(url, JsonConfig)
        if (res.status === 200) {
            const sample = JSON.parse(res.data)
            return sample;
        }
        else {
            ErrorMessage("Cannot able to get autocrawl data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get autocrawl data");
        return null;
    }
}

export const downloadCanadaAutoCrawledFiles = async () => {
    try {
        let url = `${BaseUrl}Home/DownloadZipFile_CanadaPayroll?filename=AutoCrawling_User`;
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: "blob",
        }
        const response = await axios.get(url, config);
        if (response.status === 200) {
            fileDownload(response.data, "CanadaAutoCrawlFiles.zip");
        }
        else {
            ErrorMessage("Cannot able to download");
        }
    }
    catch {
        ErrorMessage("Internal error, cannot able to download");
    }
}

export const getFolderUploadedDateCanada = async () => {
    try{
        let url = `${BaseUrl}Home/folderUploadedDate?moduleName=canada`
        const response = await axios.get(url, JsonConfig);
        const JsonResponse = response !== null ? response.data : null;
        if(JsonResponse != null){
            if(JsonResponse.statusCode === 200){
                return JsonResponse;
            }
            else {
                ErrorMessage(JsonResponse.message)
                return null
            }
        } else {
            ErrorMessage("Unable to resolve request");
            return null;
        }
    }
    catch (err){
        ErrorMessage("Unable to resolve request")
        return null
    }
}
